import styled from '@emotion/styled';
import { Stack } from '@ui-components/neo.tax';

export const ContentContainer = styled(Stack)<{ $locked?: boolean; fullWidth?: boolean }>(
  {
    height: '100%',
  },
  ({ $locked }) => ($locked ? { opacity: 0.5, pointerEvents: 'none' } : null),
  ({ fullWidth }) => (!fullWidth ? { maxWidth: 1430 } : null),
);

/** A region a page locks on its own, rather than being locked with the whole page. */
export const LockedRegionContainer = styled(Stack)<{ $locked?: boolean }>(({ $locked }) =>
  $locked ? { opacity: 0.5, pointerEvents: 'none' } : null,
);
